import { formatDetailDate, formatPropertyPrice } from "../../../utils/propertyDetailFormat";
import { getPublicSourceTrustLabel } from "../../../utils/sourceTrustLabels";

const PropertySourcesCard = ({ property }) => {
  const sources = (property?.sources || []).filter(
    (source) => source.displayName || source.sourceKey
  );

  if (!sources.length) {
    return null;
  }

  return (
    <section className="property-detail-section" aria-label="Listing sources">
      <h2 className="property-detail-section__title">Listing sources</h2>
      <ul className="property-detail-sources">
        {sources.map((source) => {
          const trust = getPublicSourceTrustLabel(source);
          const trustLabel = source.publicTrustLabel || trust.label;

          return (
            <li key={`${source.sourceKey}-${source.sourceUrl || source.price}`}>
              <div className="property-detail-sources__header">
                <strong>{source.displayName || source.sourceKey}</strong>
                {trustLabel ? <span className="property-detail-pill">{trustLabel}</span> : null}
              </div>
              <p className="property-detail-sources__meta">
                {source.price != null
                  ? formatPropertyPrice(source.price, source.currency || property.currencyCode)
                  : "Price unavailable"}
                {source.lastSeenAt ? ` · Last seen ${formatDetailDate(source.lastSeenAt)}` : ""}
                {source.status ? ` · ${source.status}` : ""}
              </p>
              {source.canonicalMatchNotice ? (
                <p className="property-detail-sources__notice">{source.canonicalMatchNotice}</p>
              ) : null}
              {source.sourceUrl ? (
                <a href={source.sourceUrl} target="_blank" rel="noreferrer">
                  View on source
                </a>
              ) : null}
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default PropertySourcesCard;
